module.exports = __webpack_public_path__ + "static/media/td.d6ccfa17.svg";